import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { MaterialModule } from '@modules/material/material.module';
import { PayrixTxnComponent } from './payrix-txn/payrix-txn.component';
import { RouterModule } from '@angular/router';
import { AllTxnComponent } from './all-txn/all-txn.component';
import { PortfolioComponent } from './portfolio/portfolio.component';
import { PaypalTxnComponent } from './paypal-txn/paypal-txn.component';
import { StripeTxnComponent } from './stripe-txn/stripe-txn.component';

@NgModule({
  declarations: [
    ConfirmDialogComponent,
    PayrixTxnComponent,
    PaypalTxnComponent,
    AllTxnComponent,
    PortfolioComponent,
    StripeTxnComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
  ],
  entryComponents: [
    ConfirmDialogComponent,
    PayrixTxnComponent,
    PaypalTxnComponent,
    AllTxnComponent,
    PortfolioComponent,
    StripeTxnComponent
  ],
  exports: [
    ConfirmDialogComponent,
    PayrixTxnComponent,
    PaypalTxnComponent,
    AllTxnComponent,
    PortfolioComponent,
    StripeTxnComponent
  ]
})
export class SharedModule { }
